/*******************************************************************************
 *		Constants / Variables
 ******************************************************************************/
//	This should be the width (in REMs) at which your full menu should be shown (matched to stylesheet)
const breakpointToDesktopNav = 82;

// Keep track of width in REMs
var widthREMs = window.innerWidth / parseFloat($("html").css("font-size"));

// Detect if IE11 or Edge
var isIE = document.body.style.msTouchAction !== undefined;
var isEdge = '-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style && !window.navigator.msPointerEnabled;

// Set expiration date for cookies (default to 1 year)
var date = new Date();
date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000));
expires = "; expires=" + date.toGMTString();


/*******************************************************************************
 *		Functions
 ******************************************************************************/
function isElementInViewport (el) {
	if (typeof jQuery === "function" && el instanceof jQuery) {
		el = el[0];
	}

	var rect = el.getBoundingClientRect();

	return (
		rect.top >= 0 &&
		rect.left >= 0 &&
		rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /*or $(window).height() */
		rect.right <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
	);
}


/*******************************************************************************
 *		jQuery : $(document).ready();
 ******************************************************************************/
$(function(){
	var dragging = false;
	$("body").on("touchmove", function(){
		dragging = true;
	});
	$("body").on("touchstart", function(){
		dragging = false;
	});

	// Object-fit polyfill
	objectFitImages(null, {watchMQ: true});

	// Fancybox
	$("[data-fancybox]").fancybox({});

	$(window).on("orientationchange resize", function(e){
		widthREMs = window.innerWidth / parseFloat($("html").css("font-size"));

		if(widthREMs >= breakpointToDesktopNav) {
			$(".site_nav .site_menu .has_children").removeClass("on");
			$(".site_nav .site_menu .has_children > ul").hide();
		}
	});

	/**
	 *		Accessibility: change font-size and contrast modes
	 */
	$(document).on("click touchend", "a[data-font-size], a[data-contrast-mode]", function(e){
		if (dragging) return;

		e.preventDefault();	// Prevent normal anchor tag behavior (page will reload as a fallback if javascript is disabled)

		var $this = $(this);

		// Update cookies and html/body element data attributes
		if($this.attr("data-font-size")) {
			$("a[data-font-size]:not([data-font-size="+$this.attr("data-font-size")+"])").removeClass("active");
			$("a[data-font-size="+$this.attr("data-font-size")+"]").addClass("active");
			$("html").attr("data-font-size", $this.attr("data-font-size"));
			document.cookie = "fontSize=" + $this.attr("data-font-size") + expires + "; path=/";
		}else
		if($this.attr("data-contrast-mode")) {
			$("a[data-contrast-mode]:not([data-contrast-mode="+$this.attr("data-contrast-mode")+"])").removeClass("active");
			$("a[data-contrast-mode="+$this.attr("data-contrast-mode")+"]").addClass("active");
			$("body").attr("data-contrast-mode", $this.attr("data-contrast-mode"));
			document.cookie = "contrastMode=" + $this.attr("data-contrast-mode") + expires + "; path=/";
		}

		$this.parents("ul").slideUp(250);
	});

	$(document).on("click touchend", ".font_sizes > a, .contrast_modes > a", function(e){
		if (dragging) return;

		e.preventDefault();
		e.stopPropagation();

		var $this = $(this);

		if($this.parent().hasClass("font_sizes")) {
			$(".contrast_modes > ul").slideUp(100);
		}else
		if($this.parent().hasClass("contrast_modes")) {
			$(".font_sizes > ul").slideUp(100);
		}
		$this.next("ul").slideToggle(250);
	});

	$(document).on("change", ".toggle_accessibility_toolbar input[name=accessibilityToolbar]", function(e){
		var $this = $(this);

		if($this.is(":checked")) {
			$("nav.accessibility").slideDown(250).addClass("is_shown");
			document.cookie = "accessibilityToolbar=on" + expires + "; path=/";
		}else{
			$("nav.accessibility").slideUp(250).removeClass("is_shown");
			document.cookie = "accessibilityToolbar=off" + expires + "; path=/";
		}
	});

	/**
	 *		Header / Nav
	 */
	$(document).on("click touchend", ".toggle.menu", function(e){
		if (dragging) return;

		e.preventDefault();
		e.stopPropagation();

		var $this = $(this);

		$this.toggleClass("on");
		$(".site_nav .site_menu").slideToggle(200);
	});

	$(document).on("click touchend", ".toggle.child", function(e){
		if (dragging) return;

		e.preventDefault();
		e.stopPropagation();

		var $this = $(this);

		$this.parent("li").toggleClass("on");
		$this.siblings("ul").slideToggle(200);
	});

	$(document).on("touchend", function(e){
		//	TODO: prevent current nav from closing and re-opening if child link is touched
		$(".site_menu ul li.has_children > a").each(function(){
			var $this = $(this);

			$this.data("is_open", false);
			$this.parent("li.has_children").removeClass("on");
			$this.siblings("ul").slideUp(200);
		});
	});

	$(document).on("touchend", ".site_menu ul li.has_children > a", function(e){
		if (dragging) return;

		var $this = $(this);

		if(widthREMs >= breakpointToDesktopNav) {
			e.stopPropagation();

			// Prevent default on anchor tag on first touch
			if(!$this.data("is_open")){
				e.preventDefault();

				// Hide other child navs
				$(".site_menu ul li.has_children").removeClass("on");
				$(".site_menu ul li.has_children ul").slideUp(200);
				$(".site_menu ul li.has_children > a").data("is_open", false);

				// Display child navigation on first touch
				$this.data("is_open", true);
				$this.parent("li.has_children").toggleClass("on");
				$this.siblings("ul").slideDown(200);
			}else{
				$this.data("is_open", false);
			}
		}
	});

	$(document).on("mouseenter", ".site_menu ul li.has_children", function(e){
		if(widthREMs >= breakpointToDesktopNav) {
			var $this = $(this);

			$this.toggleClass("on");
			$this.children("ul").slideDown(200);
		}
	});

	$(document).on("mouseleave", ".site_menu ul li.has_children", function(e){
		if(widthREMs >= breakpointToDesktopNav) {
			var $this = $(this);

			$this.toggleClass("on");
			$this.children("ul").slideUp(200);
		}
	});

	$(document).on("click touchend", ".site_nav .communities .button", function(e){
		if (dragging) return;

		e.preventDefault();

		var $this = $(this);

		$this.addClass("is_hidden");

		$this.siblings(".list").addClass("is_shown");
	});

	$(document).on("click touchend", ".site_nav .communities .list .close", function(e){
		if (dragging) return;

		e.preventDefault();

		var $this = $(this);

		$this.parents(".list").removeClass("is_shown");

		$this.parents(".communities").children(".button").removeClass("is_hidden");
	});

	/**
	 * 		Close Communities list on ESC key press
	 */
	$(document).keyup(function(e) {
		var $this = $(".communities .list");
		if ($this.hasClass("is_shown") && e.keyCode == 27) {
			$this.removeClass("is_shown");
			$this.parent(".communities").children(".button").removeClass("is_hidden").blur();
		}
	});

	/**
	 *		Find a Home bar
	 */
	$(document).on("click touchend", ".toggle_search_form", function(e){
		if (dragging) return;

		e.preventDefault();

		var $this = $(this);

		$this.parent(".wrapper").find("form").toggleClass("is_open");
	});

	/**
	 * 		Home listing
	 */
	$(document).on("click touchend", ".view.button[data-view]", function(e){
		if (dragging) return;

		e.preventDefault();

		var $this = $(this);

		if(!$this.hasClass("active")) {
			$this.parent(".wrapper").children(".view.button").not($this).removeClass("active");
			$this.addClass("active");

			$(".home_listing > section").not("." + $this.attr("data-view") + "_view").removeClass("is_shown");
			$(".home_listing > section." + $this.attr("data-view") + "_view").addClass("is_shown");

			if($this.attr("data-view") == "map") {
				$("#home_filter input[name=view]").val("map");

				// Re-initialize map
				initMap();
			}else{
				$("#home_filter input[name=view]").val("list");
			}

			// Update mobile view as well
			$(".view_switch .button").attr("data-view", $this.attr("data-view"));
		}
	});

	$(document).on("click touchend", ".view_switch .button", function(e){
		if (dragging) return;

		e.preventDefault();

		var $this = $(this);

		if($this.attr("data-view") == "map") {
			$this.attr("data-view", "list");
			$("#home_filter input[name=view]").val("list");

			$(".home_listing > section.map_view").removeClass("is_shown");
			$(".home_listing > section.list_view").addClass("is_shown");

			// Update desktop view as well
			$(".view.button[data-view=map]").removeClass("active");
			$(".view.button[data-view=list]").addClass("active");
		}else{
			$this.attr("data-view", "map");
			$("#home_filter input[name=view]").val("map");

			$(".home_listing > section.list_view").removeClass("is_shown");
			$(".home_listing > section.map_view").addClass("is_shown");

			// Re-initialize map
			initMap();

			// Update desktop view as well
			$(".view.button[data-view=list]").removeClass("active");
			$(".view.button[data-view=map]").addClass("active");
		}
	});

	$(document).on("click touchend", ".show-hide-filters", function(e){
		if (dragging) return;

		e.preventDefault();

		var $this = $(this);

		if($this.attr("data-mode") == "more") {
			// Filters currently shown, so hide
			$this.attr("data-mode", "less");
			$("#home_filter").children("[data-mode=more]").hide(250).attr("data-mode", "less");
		}else{
			// Filters currently hidden, so show
			$this.attr("data-mode", "more");
			$("#home_filter").children("[data-mode=less]").show(250).attr("data-mode", "more");
		}
	});

	/**
	 * 		Thumbnail galleries
	 */
	$(document).on("click touchend", ".photo_gallery .thumbnails a", function(e){
		if (dragging) return;

		e.preventDefault();

		var $this = $(this);

		$(".photo_gallery > a").css("display", "none");
		$(".photo_gallery > a[data-order=" + $this.attr("data-order") + "]").css("display", "block");
	});

	/**
	 * 		Share buttons
	 */
	$(document).on("click touchend", ".share_btn", function(e){
		if (dragging) return;

		e.preventDefault();

		var $this = $(this);

		$this.siblings(".oss-widget-interface").toggleClass("is_shown");
	});

	/**
	 * 		Testimonials
	 */
	$(document).on("click touchend", ".content.partial .read_more", function(e){
		if (dragging) return;

		e.preventDefault();

		var $this = $(this);

		$this.parent(".content").addClass("full");
		$this.remove();
	});

	/**
	 *		Lazy loading
	 */
	$(document).on("click touchend", ".lazy_load a", function(e){
		if (dragging) return;

 		e.preventDefault();

		$("body").addClass("is_loading");

 		var $this = $(this),
			$parentID = $this.parent().parent().attr("id");

 		$.ajax({
 			url: $this.attr("href"),
 			type: 'GET',
 			success: function(data){
				$("#"+$parentID).append( $(data).find("#"+$parentID).html() );
				$this.parent().remove();
 			},
 			complete: function(data){
 				$("body").removeClass("is_loading");
 			}
 		});
 	});

});

/******************************************************************************/